export const INITIALIZE_MAP = "INITIALIZE_MAP";
export const SET_PROPERTY = "SET_PROPERTY";
